export const deleteRequestData = [
  {
    id: 1,
    si_no: "",
    select: "",
    customer_name: "Darlee Robertson",
    customer_image: "assets/img/profiles/avatar-19.jpg",
    customer_no: "Facility Manager",
    created: "25 Sep 2023, 12:12 pm",
    delete_request: "25 Sep 2023, 12:12 pm",
    status: "Confirm",
    key: "1",
  },
  {
    id: 2,
    si_no: "",
    select: "",
    customer_name: "Sharon Roy",
    customer_image: "assets/img/profiles/avatar-20.jpg",
    customer_no: "Installer",
    created: "27 Sep 2023, 07:40 am",
    delete_request: "27 Sep 2023, 07:40 am",
    status: "Confirm",
    key: "2",
  },
  {
    id: 3,
    si_no: "",
    select: "",
    customer_name: "Vaughan",
    customer_image: "assets/img/profiles/avatar-21.jpg",
    customer_no: "Senior  Manager",
    created: "29 Sep 2023, 08:20 am",
    delete_request: "29 Sep 2023, 08:20 am",
    status: "Confirm",
    key: "3",
  },
  {
    id: 4,
    si_no: "",
    select: "",
    customer_name: "Jessica",
    customer_image: "assets/img/profiles/avatar-23.jpg",
    customer_no: "Test Engineer",
    created: "25 Sep 2023, 12:12 pm",
    delete_request: "25 Sep 2023, 12:12 pm",
    status: "Confirm",
    key: "4",
  },
  {
    id: 5,
    si_no: "",
    select: "",
    customer_name: "Carol Thomas",
    customer_image: "assets/img/profiles/avatar-16.jpg",
    customer_no: "UI /UX Designer",
    created: "02 Oct 2023, 10:10 am",
    delete_request: "02 Oct 2023, 10:10 am",
    status: "Confirm",
    key: "5",
  },
  {
    id: 6,
    si_no: "",
    select: "",
    customer_name: "Dawn Mercha",
    customer_image: "assets/img/profiles/avatar-22.jpg",
    customer_no: "Technician",
    created: "17 Oct 2023, 04:25 pm",
    delete_request: "17 Oct 2023, 04:25 pm",
    status: "Confirm",
    key: "6",
  },
  {
    id: 7,
    si_no: "",
    select: "",
    customer_name: "Rachel Hampton",
    customer_image: "assets/img/profiles/avatar-24.jpg",
    customer_no: "Software Developer",
    created: "28 Oct 2023, 07:16 am",
    delete_request: "28 Oct 2023, 07:16 am",
    status: "Confirm",
    key: "7",
  },
  {
    id: 8,
    si_no: "",
    select: "",
    customer_name: "Jonelle Curtiss",
    customer_image: "assets/img/profiles/avatar-25.jpg",
    customer_no: "Supervisor",
    created: "08 Nov 2023, 06:10 am",
    delete_request: "08 Nov 2023, 06:10 am",
    status: "Confirm",
    key: "8",
  },
  {
    id: 9,
    si_no: "",
    select: "",
    customer_name: "Jonathan",
    customer_image: "assets/img/profiles/avatar-26.jpg",
    customer_no: "Team Lead Dev",
    created: "15 Nov 2023, 11:50 am",
    delete_request: "15 Nov 2023, 11:50 am",
    status: "Confirm",
    key: "9",
  },
  {
    id: 10,
    si_no: "",
    select: "",
    customer_name: "Brook",
    customer_image: "assets/img/profiles/avatar-01.jpg",
    customer_no: "Team Lead Dev ",
    created: "25 Nov 2023, 06:34 pm",
    delete_request: "25 Nov 2023, 06:34 pm",
    status: "Confirm",
    key: "10",
  },
];
